<template>
  <el-dialog
    title="选择退换货原因"
    :visible="isShow"
    width="400px"
    @close="closeDialog"
  >
    <div class="cause-list-style">
      <el-radio-group v-model="radio">
        <el-radio
          v-for="(item, index) in isthh ? list2 : list"
          :key="index"
          :label="item.value"
        >
          {{ item.name }}
        </el-radio>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click="closeDialog">关闭</el-button>
      <el-button type="primary" @click="submitChange">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getContractNumByNewNum
} from '@/API';
export default {
  data () {
    return {
      isShow: false,
      radio: null,
      currentItem: {},
      list: [
        {
          name: '齐套不提货撤单',
          value: 1
        },
        {
          name: '产品功能问题',
          value: 2
        },
        {
          name: '产品缺货或停产',
          value: 3
        },
        // 2026 退换货优化专项：申请退换货时不再提供「其他特殊原因」（orderType=4）；
        // 原类型已拆分为税率变更、订单金额差错调整、订单基础属性变更、发票信息变更
        {
          name: '税率变更',
          value: 7
        },
        {
          name: '订单录入&发运差错',
          value: 6
        },
        {
          name: '订单金额差错调整',
          value: 8
        },
        {
          name: '订单基础属性变更',
          value: 9
        }
      ],
      list2: [
        {
          name: '市场销售原因',
          value: 5
        }
      ]
    };
  },
  props: {
    isthh: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submitChange () {
      if (!this.radio) return this.$message.error('请选择一项原因');
      getContractNumByNewNum({
        newNum: this.currentItem.reNewContractNum
      }).then(res => {
        const { status, data } = res.data;
        if (status === '200') {
          let Base64 = require('js-base64').Base64;
          let loginType = localStorage.getItem('loginType');
          let orderUrl = `/returnExchange/edit?orderType=${this.radio}&systemSource=${data.systemSource}&serialNum=${data.serialNum}&customerPoNum=${data.customerPoNum || ''}&serialNumXn=${data.serialNumXn}`;
          let url = Base64.encode(orderUrl);
          let returnExchangePath = '';

          let sidUrl = `https://sid.ruijie.com.cn/`;
          if (loginType) {
            if (window._env_.NODE_ENV === 'pro') {
              returnExchangePath = `${sidUrl}channel/login?service=${encodeURIComponent(`https://rjop.ruijie.com.cn/login?route=${url}&loginType=${loginType}`)}`;
            } else if (window._env_.NODE_ENV === 'test') {
              returnExchangePath = `${sidUrl}channel/login?service=${encodeURIComponent(`https://order-platform-test.ruijie.com.cn/login?route=${url}&loginType=${loginType}`)}`;
            } else if (window._env_.NODE_ENV === 'uat') {
              returnExchangePath = `${sidUrl}channel/login?service=${encodeURIComponent(`https://order-platform-uat.ruijie.com.cn/login?loginType=${loginType}&route=${url}`)}`;
            } else {
              returnExchangePath = `http://order-platform-uat.ruijie.com.cn${orderUrl}`;
            }
          } else {
            if (window._env_.NODE_ENV === 'pro') {
              returnExchangePath = `${sidUrl}login?service=http://rjop.ruijie.com.cn/login?route=${url}`;
            } else if (window._env_.NODE_ENV === 'test') {
              returnExchangePath = `${sidUrl}login?service=http://order-platform-test.ruijie.com.cn/login?route=${url}`;
            } else if (window._env_.NODE_ENV === 'uat') {
              returnExchangePath = `${sidUrl}login?service=http://order-platform-uat.ruijie.com.cn/login?route=${url}`;
            } else {
              returnExchangePath = `http://order-platform-uat.ruijie.com.cn${orderUrl}`;
            }
          }
          window.location.href = returnExchangePath;
        }
      });
    },

    openDialog (row) {
      this.isShow = true;
      this.currentItem = row;
    },

    closeDialog () {
      this.isShow = false;
      this.radio = 1;
      this.currentItem = {};
    }
  }
};
</script>

<style scoped>
  /* 退换货原因选项：两列等宽（每项固定 50% 宽）并两两成行，
     让左右两列的圆点与文字严格对齐，避免名称长短不一
     （如“订单录入&发运差错”比“税率变更”长）把第二列挤得参差不齐。

     ⚠️ .el-radio-group / .el-radio 由 Element UI 子组件渲染，不带本组件的 data-v 属性，
     scoped 下必须用 ::v-deep 穿透，否则规则不生效、选项仍参差。
     与 ../assistantContractList/contractQuery.vue 保持一致。 */
  ::v-deep .cause-list-style > .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }

  ::v-deep .cause-list-style > .el-radio-group .el-radio {
    box-sizing: border-box;
    flex: 0 0 50%;
    display: flex;
    align-items: center;
    min-width: 0;
    margin: 0 0 8px;
    padding-right: 8px;
    line-height: 22px;
  }

  ::v-deep .cause-list-style > .el-radio-group .el-radio__label {
    padding-left: 8px;
    white-space: normal;
    overflow-wrap: break-word;
  }
</style>
